<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="来源"
                  prop="source"
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.source"
                    :disabled="eventType === 'view'"
                  >
                    <el-radio :label="1">
                      云南中烟物资
                    </el-radio>
                    <el-radio :label="2">
                      恒睿盛格物资物资
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item
                  label="物料类型"
                  prop="sortId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.sortId"
                    filterable
                    clearable
                    placeholder="请选择类别"
                    style="width:100%"
                    @change="changeSortFun"
                  >
                    <el-option
                      v-for="item in sortOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.sortName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="品牌"
                  prop="brandId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.brandId"
                    filterable
                    clearable
                    placeholder="请选择品牌"
                    style="width:100%"
                    @change="changeBrandFun"
                  >
                    <el-option
                      v-for="item in brandOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.brandName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item
                  label="规格"
                  prop="specification"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.specification"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="云南中烟物料名称"
                  :prop="dialogAddEditViewForm.source === 1 ? 'nameOfZy' : ''"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.nameOfZy"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="云南中烟物料编号"
                  :prop="dialogAddEditViewForm.source === 1 ? 'codeOfZy' : ''"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.codeOfZy"
                    maxlength="64"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="最小单位"
                  prop="minimumUnit"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.minimumUnit"
                    maxlength="32"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="包装单位"
                  prop="packageUnit"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.packageUnit"
                    maxlength="32"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditViewForm.packageUnit"
                :span="6"
              >
                <el-form-item
                  label="包装数量"
                  prop="packageNum"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.packageNum"
                    :min="0"
                    :max="9999999.99"
                    :precision="2"
                    :controls="false"
                    style="width: 100%;"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            合同服务项目对应关系
            <el-button
              v-if="eventType !== 'view'"
              size="mini"
              icon="el-icon-circle-plus-outline"
              plain
              style="float:right; margin-top:0.1em; margin-right:15px;"
              @click="addContractServiceItemFun"
            >
              添加合同服务项目
            </el-button>
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-table
                  :data="dialogAddEditViewForm.contractItemData"
                  class="public-table"
                  style="width: 100%; margin-bottom: 5px;"
                  :header-cell-style="{background:'#0076ff'}"
                  border
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                  />
                  <el-table-column
                    label="年份"
                    prop="year"
                    align="center"
                    width="60"
                  />
                  <el-table-column
                    label="省区"
                    prop="provinceName"
                    align="center"
                    width="120"
                  />
                  <el-table-column
                    v-if="eventType !== 'view'"
                    label="服务项目"
                    align="center"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'contractItemData.' + scope.$index + '.contractItemId'"
                        :rules="dialogAddEditViewFormRules.contractItemId"
                      >
                        <el-select
                          v-model="scope.row.contractItemId"
                          filterable
                          clearable
                          placeholder="请选择合同服务项目"
                          style="width:100%"
                          @change="contractItemChangeFun(scope.row, $event)"
                        >
                          <el-option
                            v-for="item in contractItemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                            <span style="float: left">{{ item.label }}</span>
                            <span style="float: right; color: #8492a6; font-size: 12px">{{ item.yearProvince }}</span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-else
                    prop="itemName"
                    label="服务项目"
                    header-align="center"
                    width="160"
                  />
                  <el-table-column
                    prop="itemUnit"
                    label="单位"
                    align="center"
                    width="60"
                  />
                  <el-table-column
                    prop="itemRemark"
                    label="服务项目备注"
                    header-align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    v-if="eventType !== 'view'"
                    label="操作"
                    width="60"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <i
                        class="el-icon-delete"
                        style="color: red; font-size: 16px;"
                        @click="handleDeleteContractItem(scope.$index)"
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listDictApi } from '@/api/v2/dict'
import { listContractServiceItemApi } from '@/api/v2/contractServiceItem'
import { viewMaterialsApi, saveMaterialsApi } from '@/api/v2/materials'
// 旧版API
import { brandListSelectDataApi } from '@/api/brand'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        source: [{ required: true, message: '请选择来源', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        codeOfZy: [{ required: false, message: '请输入云南中烟物料编码', trigger: 'blur' }],
        nameOfZy: [{ required: true, message: '请输入云南中烟物料名称', trigger: 'blur' }],
        specification: [{ required: false, message: '请输入规格', trigger: 'blur' }],
        sortId: [{ required: true, message: '请选择物料类型', trigger: 'change' }],
        brandId: [{ required: true, message: '请选择物料品牌', trigger: 'change' }],
        minimumUnit: [{ required: true, message: '请输入最小单位', trigger: 'blur' }],
        packageUnit: [{ required: false, message: '请输入包装单位', trigger: 'blur' }],
        packageNum: [{ required: true, message: '请输入包装数量', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        contractItemId: [{ required: true, message: '请选择对应的合同服务项目', trigger: 'change' }]
      },
      sortOptions: [],
      brandOptions: [],
      contractItemOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this

        _this.sortOptions = []
        _this.brandOptions = []
        _this.contractItemOptions = []
        _this.dialogAddEditViewForm = {
          source: 1,
          name: '',
          codeOfZy: '',
          nameOfZy: '',
          specification: '',
          sortId: null,
          sortName: '',
          brandId: null,
          brandName: '',
          minimumUnit: '',
          packageUnit: '',
          packageNum: null,
          remark: '',
          contractItemData: []
        }

        if (_this.eventType !== 'view') {
          _this.initSortSelectData()
          _this.initBrandSelectData()
          _this.initContractItemSelectData()
        }

        if (_this.eventType !== 'add') {
          _this.loadMaterialsData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadMaterialsData () {
      let _this = this
      viewMaterialsApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          if (!data[key]) continue
          _this.dialogAddEditViewForm[key] = data[key]
        }
        if (data.contractItemDataArray) {
          _this.dialogAddEditViewForm.contractItemData = data.contractItemDataArray
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    // 初始类别下拉数据
    initSortSelectData () {
      listDictApi({ type: 2 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.sortOptions.push({ label: item.optionLabel, data: item.optionValue })
        })
      })
    },
    // 选择类别回调
    changeSortFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.sortOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.sortName = selectItem ? selectItem.label : ''
    },
    // 初始品牌下拉数据
    initBrandSelectData () {
      brandListSelectDataApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.brandOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择品牌回调
    changeBrandFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.brandOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.brandName = selectItem ? selectItem.label : ''
    },
    // 初始化合同服务项目(物料制作)选项
    initContractItemSelectData () {
      let _this = this
      _this.contractItemOptions = []
      listContractServiceItemApi({ type: 4, orderBy: 'tcs.year desc, tcs.province_id asc' }).then(response => {
        const { data } = response
        data.forEach((item) => {
          _this.contractItemOptions.push({
            value: item.id,
            label: item.name,
            year: item.year,
            provinceName: item.provinceName,
            itemUnit: item.unit,
            itemRemark: item.remark,
            yearProvince: item.year + ' - ' + item.provinceName
          })
        })
      })
    },
    // 增加对应的合同服务项目
    addContractServiceItemFun () {
      this.dialogAddEditViewForm.contractItemData.push({
        contractItemId: '',
        year: '',
        provinceName: '',
        itemUnit: '',
        itemRemark: ''
      })
    },
    // 删除对应的合同服务项目
    handleDeleteContractItem (index) {
      this.dialogAddEditViewForm.contractItemData.splice(index, 1)
    },
    // 合同服务项目选择回调
    contractItemChangeFun (row, val) {
      let selectedItem = {}
      if (val) {
        selectedItem = this.contractItemOptions.find(item => {
          return item.value === val
        })
      }
      row.year = selectedItem.year || ''
      row.provinceName = selectedItem.provinceName || ''
      row.itemUnit = selectedItem.itemUnit || ''
      row.itemRemark = selectedItem.itemRemark || ''
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '基础物料设置', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
              if (!_this.dialogAddEditViewForm.packageUnit) {
                _this.dialogAddEditViewForm.packageNum = null;
              }

              _this.dialogAddEditViewForm.contractItemJsonData = JSON.stringify(_this.dialogAddEditViewForm.contractItemData)
              saveMaterialsApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
